module.exports = __webpack_public_path__ + "img/chivas-bottle.a0076641.jpg";